import { Component } from "react"
import classNames from "classnames"
import PropTypes from "prop-types"
import { select } from "d3-selection"

class Axis extends Component {
  static propTypes = {
    fn: PropTypes.func.isRequired,
    className: PropTypes.string,
    transform: PropTypes.string.isRequired,
    labelTransform: PropTypes.object,
    position: PropTypes.string,
    title: PropTypes.string,
  }

  draw = () => {
    const { ref, props: { fn } } = this

    select(ref)
      .call(fn)
  }

  componentDidUpdate() {
    this.draw()
  }

  setRef = node => {
    this.ref = node
    this.draw()
  }

  render() {
    const { transform, className, labelTransform, title, position } = this.props
    return <g className={classNames("axis", className)}>
      <g ref={this.setRef} transform={transform} />
      {title && labelTransform
        && <g textAnchor="middle" transform={`translate(${labelTransform.x}, ${labelTransform.y})`}>
          <text
            y={position === "right" ? -10 : 15}
            style={{
              transform: position === "right" ? "rotate(90deg)" : "rotate(-90deg)",
            }}
          >
            {title}
          </text>
        </g>}
    </g>
  }
}

export default Axis
